import { SponsorCompanyTier } from "src/api/types.generated";

export const speakingTime = (companyTier?: SponsorCompanyTier) => {
  switch (companyTier) {
    case SponsorCompanyTier.Gold:
      return "3 minutes";
    default:
      return "1 minute";
  }
};
